import actionTypes from '../constants/actionTypes';
import createFetchingHandlers from '../../../../utils/createFetchingHandlers';
import createListReducer from '../../../../utils/createListReducer';

const { CLOSURE_ITEMS_FETCH, CLOSURE_ITEMS_SUCCESS, CLOSURE_ITEMS_ERROR } = actionTypes;

const initialState = {
  data: [],
  metadata: {},
};

const fetchingData = createFetchingHandlers([CLOSURE_ITEMS_FETCH, CLOSURE_ITEMS_SUCCESS, CLOSURE_ITEMS_ERROR], () => ['metadata', 'fetchingData']);
const getDataHandler = {
  [CLOSURE_ITEMS_SUCCESS]: (state, action) => {
    const outputState = { ...state };
    outputState.data = { ...action?.payload };
    return { ...outputState };
  },
};

export default createListReducer(initialState, [fetchingData, getDataHandler]);
